import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setPortalTierPricesAction,
  setPortalTierPriceAction,
  setPortalTierPricesStatusAction,
  setPortalTierPricesErrorsAction,
  clearPortalTierPricesErrorsAction
} from './portalTierPrices.actions'

export const fetchPortalTierPrices = portalId => async dispatch => {
  dispatch(setPortalTierPricesStatusAction('loading'))
  dispatch(clearPortalTierPricesErrorsAction())

  try {
    const { data } = await branditRails.get(`/portals/${portalId}/portal_tier_prices`)

    // Convert array to object with id as key
    const portalTierPricesById = data.reduce((acc, portalTierPrice) => {
      acc[portalTierPrice.id] = portalTierPrice
      return acc
    }, {})

    dispatch(setPortalTierPricesAction(portalTierPricesById))
    dispatch(setPortalTierPricesStatusAction('succeeded'))

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setPortalTierPricesErrorsAction({ message: errorMessage }))
    dispatch(setPortalTierPricesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const createPortalTierPrice = (portalId, formData) => async dispatch => {
  dispatch(setPortalTierPricesStatusAction('loading'))
  dispatch(clearPortalTierPricesErrorsAction())

  try {
    const { data } = await branditRails.post(`/portals/${portalId}/portal_tier_prices`, formData)

    dispatch(setPortalTierPriceAction(data))
    dispatch(setPortalTierPricesStatusAction('succeeded'))
    toastr.success('Success', 'Portal tier price created successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setPortalTierPricesErrorsAction({ message: errorMessage }))
    dispatch(setPortalTierPricesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const deletePortalTierPrice = (portalId, id) => async dispatch => {
  dispatch(setPortalTierPricesStatusAction('loading'))
  dispatch(clearPortalTierPricesErrorsAction())

  try {
    await branditRails.delete(`/portals/${portalId}/portal_tier_prices/${id}`)

    dispatch(setPortalTierPricesStatusAction('succeeded'))
    toastr.success('Success', 'Portal tier price deleted successfully!')

    return true
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setPortalTierPricesErrorsAction({ message: errorMessage }))
    dispatch(setPortalTierPricesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const updatePortalTierPrice = (portalId, tierId, formData) => async dispatch => {
  dispatch(setPortalTierPricesStatusAction('loading'))
  dispatch(clearPortalTierPricesErrorsAction())

  try {
    const { data } = await branditRails.patch(`/portals/${portalId}/portal_tier_prices/${tierId}`, formData)

    dispatch(setPortalTierPriceAction(data))
    dispatch(setPortalTierPricesStatusAction('succeeded'))
    toastr.success('Success', 'Portal tier price updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setPortalTierPricesErrorsAction({ message: errorMessage }))
    dispatch(setPortalTierPricesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const bulkUpdatePortalTierPrices = (tiersData, portalId) => async dispatch => {
  dispatch(setPortalTierPricesStatusAction('loading'))
  dispatch(clearPortalTierPricesErrorsAction())

  try {
    const { data: portalTierPrices } = await branditRails.post(`/portals/${portalId}/portal_tier_prices`, {
      portal_tier_prices: tiersData
    })

    const portalTierPricesById = portalTierPrices.reduce((acc, portalTierPrice) => {
      acc[portalTierPrice.id] = portalTierPrice
      return acc
    }, {})

    dispatch(setPortalTierPricesAction(portalTierPricesById))
    dispatch(setPortalTierPricesStatusAction('succeeded'))
    toastr.success('Success', 'Portal tier prices updated successfully!')

    return portalTierPrices
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setPortalTierPricesErrorsAction({ message: errorMessage }))
    dispatch(setPortalTierPricesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
